import { ROUTES_KEYS_MAP } from '@/config/router/key-routes-mapping';

export { ROUTES_KEYS_MAP };

export const ROUTES_PATHS = {
  [ROUTES_KEYS_MAP.HOME]: '/',
  [ROUTES_KEYS_MAP.LOGIN]: '/login',
  [ROUTES_KEYS_MAP.FORGOT_PASSWORD]: '/forgot-password',
  [ROUTES_KEYS_MAP.SET_PASSWORD]: '/set-password',
  [ROUTES_KEYS_MAP.RESET_PASSWORD]: '/reset-password',
  [ROUTES_KEYS_MAP.NOT_FOUND]: '/not-found',
  [ROUTES_KEYS_MAP.SOMETHING_WENT_WRONG]: '/something-went-wrong',
  [ROUTES_KEYS_MAP.UNAUTHORIZED]: '/unauthorized',

  // PARTNER ROUTES
  [ROUTES_KEYS_MAP.CITY_MAPPING]: '/city-mapping',
  [ROUTES_KEYS_MAP.OMNIFUL_COUNTRY_CITIES]: '/omniful-country-cities',
  [ROUTES_KEYS_MAP.SHIPPING_PARTNER_CITY_MAPPING]: '/shipping-partner-city-mapping',
  [ROUTES_KEYS_MAP.SALES_CHANNEL_CITY_MAPPING]: '/sales-channel-city-mapping',
  [ROUTES_KEYS_MAP.OMNIFUL_CITIES]: '/omniful-cities',
  [ROUTES_KEYS_MAP.OMNIFUL_STATE]: '/omniful-states',
  [ROUTES_KEYS_MAP.OMNIFUL_COUNTRY]: '/omniful-countries',
  [ROUTES_KEYS_MAP.TENANTS]: '/tenants',
  [ROUTES_KEYS_MAP.SELLER]: '/seller',
  [ROUTES_KEYS_MAP.SKUS]: '/skus',
  [ROUTES_KEYS_MAP.HUBS]: '/hubs',
  [ROUTES_KEYS_MAP.DEFAULT]: '*',

  // ORDERS ROUTES
  [ROUTES_KEYS_MAP.ORDERS]: '/orders',

  // BILLING ROUTES
  [ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY]: '/billing/omniful-entity',
  [ROUTES_KEYS_MAP.BILLING_TENANT_ENTITY]: '/billing/tenant-entity',
  [ROUTES_KEYS_MAP.BILLING_PROFILE]: '/billing/profile',
  [ROUTES_KEYS_MAP.BILLING_SINGLE_PROFILE]: '/billing/profile/view',
  [ROUTES_KEYS_MAP.BILLING_PROFILE_CREATE]: '/billing/profile/create',
  [ROUTES_KEYS_MAP.BILLING_CONTRACTS]: '/billing/contracts',
  [ROUTES_KEYS_MAP.BILLING_SINGLE_CONTRACT]: '/billing/contracts/view',
  [ROUTES_KEYS_MAP.BILLING_BILLS]: '/billing/bills',
  [ROUTES_KEYS_MAP.BILLING_SINGLE_BILL]: '/billing/bills/view',
  [ROUTES_KEYS_MAP.BILLING_TRANSACTIONS]: '/billing/transactions',
  [ROUTES_KEYS_MAP.BILLING_AD_HOC_ACTIVITIES]: '/billing/ad-hoc-activities',
  [ROUTES_KEYS_MAP.BILLING_AD_HOC_USAGE]: '/billing/ad-hoc-usage',

  // SETTINGS ROUTES
  [ROUTES_KEYS_MAP.SALES_CHANNEL_APPS]: '/settings/sales-channel-apps',
  [ROUTES_KEYS_MAP.SELLER_SALES_CHANNELS]: '/settings/seller-sales-channels',
  [ROUTES_KEYS_MAP.SHIPPING_APPS_CONFIG]: '/settings/shipping-apps-config',
  [ROUTES_KEYS_MAP.USERS_SETTINGS]: '/settings/users-settings',
  [ROUTES_KEYS_MAP.ROLES_SETTINGS]: '/settings/roles-settings',

  // PRICING PLANS ROUTES
  [ROUTES_KEYS_MAP.PRICING_PLANS]: '/pricing-plans',
}
